import _ from 'lodash';
import { Vue, Component, Prop } from 'vue-property-decorator';

import { Setting as terms } from '@/const/terms/mainTerms';
import { ComponentTerms as compTerms } from '@/const/terms/componentTerms';

import { ID_TYPE, AD_FORMAT, ADJUSTMENT_TYPE, INVENTORY_TYPE, IINVENTORY } from '@/const/types';
import { AD_FORMAT_MAP, INVENTORY_TYPE_MAP } from '@/const/options';
import { FormType, INativeInventory } from '@/pages/campaign/adset/editingTypes';
import { IInventory } from '@/pages/campaign/adset/editingTypes';
import { InitialSchedule } from '@/pages/campaign/adset/editingData';
import { CampaignInfoResponse } from '@/pages/campaign/editingTypes';
import { IAudienceData } from '@/pages/audience/types';

import { ValidateFieldCallback } from 'element-ui/types/form';

import Select from '@/components/ElementComponent/Select/index.vue';
import FormDateTimeRangePicker from '@/components/ElementComponent/Date/FormDateTimeRangePicker.vue';
import AdsetTransferOfInventory from './AdsetTransferOfInventory.vue';
// tables
import AdsetTableOfStatus from './AdsetTableOfStatus.vue';
import AdsetTableOfPrice from './AdsetTableOfPrice.vue';
import AdsetTableOfBudget from './AdsetTableOfBudget.vue';
import AdsetTableOfLandingURL from './AdsetTableOfLandingURL.vue';
import AdsetTableOfNativeInfo from './AdsetTableOfNativeInfo.vue';
// details
import AudienceSelectDialog from './AudienceSelectDialog.vue';
import ScheduleTableSelector from './ScheduleTableSelector.vue';
@Component<AdsetForm>({
    name: 'AdsetForm',
    components: {
        Select,
        FormDateTimeRangePicker,
        AdsetTransferOfInventory,
        // tables
        AdsetTableOfStatus,
        AdsetTableOfPrice,
        AdsetTableOfBudget,
        AdsetTableOfLandingURL,
        AdsetTableOfNativeInfo,
        //details
        AudienceSelectDialog,
        ScheduleTableSelector,
    }
})
export default class AdsetForm extends Vue {
    @Prop({ type: Object, required: true })
    readonly value!: FormType;

    @Prop({ type: Boolean, required: true })
    readonly isEdit!: boolean;

    @Prop({ type: Object, required: true })
    readonly campaignData!: CampaignInfoResponse;

    @Prop({ type: Array, required: true})
    readonly inventoryList!: IInventory[];
    
    get form() {
        return this.value
    }
    set form(v: FormType) {
        this.$emit('input', v)
    }

    terms = terms;
    compTerms = compTerms;
    
    AD_FORMAT_MAP = AD_FORMAT_MAP;
    INVENTORY_TYPE_MAP = INVENTORY_TYPE_MAP;

    audienceSelectDialogVisible: boolean = false;
    
    get targets() {
        const val: ID_TYPE[] = this.form.targetInventory;

        const targetItems = this.inventoryList.filter((v: IInventory) => !v.disabled && val.includes(v.placement_id));
        const existingBudgets: {[invID: string]: IInventory} = {};
        const targets = this.form.targets = [] as IInventory[]
        targets.forEach((v: IInventory) => {
            if (val.includes(v.id)) {
                existingBudgets[v.id] = v;
            }
        })
        this.form.targets = targetItems.map((item: IInventory) => {
            if (existingBudgets[item.placement_id]) {
                return existingBudgets[item.placement_id];
            }
            return item;
        })
        return this.form.targets as IInventory[];
    }
    get nativeTargets() {
        const val: ID_TYPE[] = this.form.targetInventory;

        const targetItems = this.inventoryList.filter((v: IInventory) => !v.disabled && val.includes(v.placement_id));
        const existingBudgets: {[invID: string]: IInventory} = {};
        const targets = this.form.targets = [] as IInventory[]
        targets.forEach((v: IInventory) => {
            if (val.includes(v.id)) {
                existingBudgets[v.id] = v;
            }
        })
        this.form.targets = targetItems.map((item: IInventory) => {
            if (existingBudgets[item.placement_id]) {
                return existingBudgets[item.placement_id];
            }
            return item;
        })
        return this.form.targets.filter((t) => t.type === INVENTORY_TYPE.native).map((t) => {
            const nativeT = t as INativeInventory;
            if (!nativeT.native_info) {
                this.$set(nativeT, 'native_info', {
                    title: '',
                    description: '',
                    cta_text: '',
                });
            }
            return nativeT;
        });
    }

    private setScheduleDefault() {
        this.form.impressionSchedule = {
            isUsed: this.form.impressionSchedule.isUsed, 
            impSchedule: _.cloneDeep(InitialSchedule),
        };
    }
    
    
    private nameValidator(rules: any, values: string, callback: ValidateFieldCallback) {
        if (this.form.isLegacy) {
            (callback as any)();
            return;
        } 
        if (values.includes('-')) {
            callback(compTerms.form.adset.name.error.invalidHyphen);
            return;
        }
        (callback as any)();
    }

    public checkNativeInfo(rules: any, values: any, callback: ValidateFieldCallback ) {
        (((this.form.targets as IInventory[]).filter((t) => t.type === INVENTORY_TYPE.native)) as INativeInventory[]).forEach((item: INativeInventory) => {
            if (!(item.native_info && item.native_info.title && item.native_info.title !== '')) {
                callback(compTerms.form.adset.nativeInfo.title.required);
                return;
            }
            if (!(item.native_info && item.native_info.description && item.native_info.description !== '')) {
                callback(compTerms.form.adset.nativeInfo.nativeDescription.required);
                return;
            }
            if (!(item.native_info && item.native_info.cta_text && item.native_info.cta_text !== '')) {
                callback(compTerms.form.adset.nativeInfo.ctaText.required);
                return;
            }
        });
        (callback as any)();
    }

    public checkAllLandingURL(rules: any, values: any, callback: ValidateFieldCallback) {
        (this.form.targets as IInventory[]).forEach((item: IInventory) => {
            if (!item.landingURL) {
                callback(compTerms.form.adset.landingURL.error.required)
                return;
            }
        });
        (callback as any)();
    }
    public checkEachBudgets(rules: any, values: any, callback: ValidateFieldCallback) {
        if (this.form.budget && this.campaignData.budget.limited) {
            const num = (this.form.targets as IInventory[]).reduce((pre: number, item: IInventory) => pre + item.budget, 0)
            if (this.campaignData.budget.value !== num) {
                callback(compTerms.form.adset.budget.error.shouldBeSameBudget)
                return;
            }
        }
        (callback as any)();
    }
    public checkIsPriceZero(rule: object, value: IInventory[], callback: any) {        
        let valid = (this.form.targets as IInventory[]).reduce((isValid: boolean, inv: IInventory) => {
            if (inv.price.type !== ADJUSTMENT_TYPE.FREE) {
                if (inv.price.value > 0) {
                    return isValid && true;
                }
            } else {
                return isValid && true;
            }
            return false;
        }, true)
        if (valid) {
            callback();
            return true;
        } else {
            const r = rule as {message: string};
            callback(new Error(r.message));
            return false;
        }
    }

    public removeAudience(audience: IAudienceData, index: number) {
        this.form.audience.splice(index, 1);
    }
}
        